import { render, staticRenderFns } from "./SubmitProductMixCard.vue?vue&type=template&id=1e07584e&scoped=true&"
import script from "./SubmitProductMixCard.vue?vue&type=script&lang=js&"
export * from "./SubmitProductMixCard.vue?vue&type=script&lang=js&"
import style0 from "./SubmitProductMixCard.vue?vue&type=style&index=0&id=1e07584e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e07584e",
  null
  
)

export default component.exports